export type DiffRecord = Record<string, unknown> | undefined;

/** Top-level keys whose serialized value differs between the two records. */
export function changedKeys(before: DiffRecord, after: DiffRecord): Set<string> {
  const b = before ?? {};
  const a = after ?? {};
  const changed = new Set<string>();
  for (const k of new Set([...Object.keys(b), ...Object.keys(a)])) {
    if (JSON.stringify(b[k]) !== JSON.stringify(a[k])) changed.add(k);
  }
  return changed;
}

/**
 * Serialize one side of the diff: top-level keys sorted, `undefined` dropped,
 * so both columns line up key-for-key.
 *
 * The ordered object is built explicitly rather than handing the key list to
 * `JSON.stringify` as a replacer array. A replacer array filters at EVERY
 * depth, so nested maps whose own keys aren't also top-level config keys
 * (`apps`, `groups`, `creditConfig`, `sharePointConfigs`, `webCrawlerConfigs`)
 * serialized as `{}` — the row was correctly flagged as changed while showing
 * an empty block on both sides, hiding exactly the edit being confirmed.
 */
export function serializeForDiff(obj: DiffRecord): string {
  const record = obj ?? {};
  const ordered: Record<string, unknown> = {};
  for (const k of Object.keys(record)
    .filter((k) => record[k] !== undefined)
    .sort()) {
    ordered[k] = record[k];
  }
  return JSON.stringify(ordered, null, 2);
}
